import {
  NotificationPreference,
  NotificationPreferencesProps,
  NotificationPreferencesSection,
} from '@ecosystem/newron-client-lib';
import React, { useEffect, useState } from 'react';

export const GroupSharingNotification: React.FC<NotificationPreferencesProps> = (
  props: NotificationPreferencesProps,
) => {
  const [filteredPreferences, setFilteredPreferences] = useState<NotificationPreference>({
    type: '',
    settings: { email: false, push: true },
    context: {} as any,
  });

  useEffect(() => {
    setFilteredPreferences(props.preferences);
  }, [props.preferences]);

  return (
    <NotificationPreferencesSection
      title="Groups"
      type="shared-groups"
      preferences={filteredPreferences}
      onChange={props.onChange}
      email
      push
      key="groups"
      checkBoxTestId="shared-groups-checkbox"
    />
  );
};
